<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div id="data-list-thumb-view" class="data-list-container">
      <vx-card title>
        <div class="mt-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 w-1/5 mt-5">
              <h6 class="mb-2">Data Contrato</h6>
              <div>
                <datepicker
                  placeholder="Selecione a Data"
                  :language="languages['ptBR']"
                  format="dd/MM/yyyy"
                  v-model="date"
                ></datepicker>
              </div>
            </div>
            <div class="vx-col md:w-1/5 w-1/5 mt-5">
              <h6 class="mb-2">Número</h6>
              <vs-input class="w-full" v-model="number" />
            </div>
          </div>
          <br />
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Tipo</h6>
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    color="warning"
                    v-model="type"
                    vs-value="Sem Contrato"
                    >Sem Contrato</vs-radio
                  >
                </li>
                <li>
                  <vs-radio color="primary" v-model="type" vs-value="Locação"
                    >Locação</vs-radio
                  >
                </li>
                <li>
                  <vs-radio color="success" v-model="type" vs-value="Ouro"
                    >Ouro</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
          <br />
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Código Contrato</h6>
              <h3 class="mb-2">{{ idContractPermanentAsset }}</h3>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Nome Cliente</h6>
              <h3 class="mb-2">{{ corporateName }}</h3>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Nome Fantasia</h6>
              <h3 class="mb-2">{{ fantasyName }}</h3>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Código ILUX</h6>
              <h3 class="mb-2">{{ idIlux }}</h3>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Cidade</h6>
              <h3 class="mb-2">{{ city }}</h3>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="cnpj">
              <h6 class="mb-2">CNPJ</h6>
              <h3 class="mb-2">{{ cnpj }}</h3>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="cpf">
              <h6 class="mb-2">CPF</h6>
              <h3 class="mb-2">{{ cpf }}</h3>
            </div>
          </div>
        </div>
      </vx-card>
      <br />
      <vx-card title>
        <div class="mt-5">
          <div class="vx-row">
            <div class="vx-col w-full mt-5">
              <input
                multiple
                type="file"
                class="hidden"
                ref="attachmentInput"
                @change="attachFile()"
                accept="
                  application/pdf, 
                  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, 
                  application/msword,
                  application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
                  image/png, image/gif, image/jpeg, image/jpg"
                name="file"
              />
              <vs-button color="primary" @click="$refs.attachmentInput.click()">
                Selecione os arquivos
              </vs-button>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mt-5">
              <vs-list :key="indextr" v-for="(item, indextr) in newFiles">
                <vs-list-item
                  :title="item.fileName"
                  :subtitle="item.type"
                ></vs-list-item>
              </vs-list>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mt-5" v-show="showSaveButton == true">
              <vs-button class="float-right" color="success" @click="submitFile"
                >Salvar</vs-button
              >
              <vs-button class="float-left" color="warning" @click="clean"
                >Limpar</vs-button
              >
            </div>
          </div>
        </div>
      </vx-card>
      <br />
      <vx-card title>
        <div class="mt-5">
          <div>
            <vue-good-table
              ref="my-table"
              selectionInfoClass="mytable"
              style="width: 100%"
              styleClass="vgt-table condensed"
              :search-options="{
                enabled: true,
                trigger: '',
                placeholder: 'Procurar',
                skipDiacritics: true,
              }"
              :pagination-options="paginationOptions"
              :columns="columns"
              :rows="files"
              @on-row-click="onRowClick"
            >
              <div slot="emptystate" class="text-center">
                Nenhum resultado encontrado
              </div>
              <template slot="table-row" slot-scope="file">
                <span
                  class="font-medium"
                  v-if="file.column.field == 'idItemContractPermanentAsset'"
                >
                  <vs-chip color="success">
                    {{ file.row.idItemContractPermanentAsset }}</vs-chip
                  >
                </span>
                <span
                  class="font-medium"
                  v-if="file.column.field == 'fileName'"
                >
                  {{ file.row.fileName }}
                </span>
                <span
                  class="font-medium"
                  v-if="file.column.field == 'createAt'"
                >
                  {{ file.row.createAt }}
                </span>
                <span
                  class="font-medium"
                  v-if="file.column.field == 'download'"
                >
                  <feather-icon
                    icon="DownloadIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="
                      downloadFile(file.row.fileName,file.row.file,file.row.type)
                    "
                  />
                </span>
                <span class="font-medium" v-if="file.column.field == 'delete'">
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="
                      deleteFile(file.row.idItemContractPermanentAsset)
                    "
                  />
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </vx-card>
      <br />
      <vx-card title v-show="items.length > 0">
        <div class="mt-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 mt-5">
              <h6 class="mb-2">Equipamentos no Contrato</h6>
              <br />
              <div
                v-for="(item, index) of items"
                :key="index"
                :title="item.idPermanentAsset"
                color="primary"
                active="true"
              >
                <div v-lazy-container="{ selector: 'img' }">
                  <img
                    key="onlineImg"
                    v-bind:data-src="item.photoProduct"
                    alt="product-img"
                    width="100"
                    height="100"
                    class="
                      product-img
                      rounded-none
                      shadow-md
                      cursor-pointer
                      block
                    "
                    @click="
                      $router
                        .push(`/ativos/${item.idPermanentAsset}`)
                        .catch((err) => {})
                    "
                  />
                </div>

                <br />
                <p>Nome: {{ item.name }}</p>
                <p>Serial: {{ item.serialNumber }}</p>
                <p>Patrimônio: {{ item.patrimony }}</p>
                <p>NF de Entrada: {{ item.nf }}</p>
                <p>NF de Saída: {{ item.outgoingInvoice }}</p>
                <p>Setor: {{ item.sector }}</p>
                <p>Preço: {{ item.price }}</p>
                <br />
              </div>
            </div>
          </div>
        </div>
      </vx-card>

      <div class="mt-5">
        <div class="vx-row">
          <div class="vx-col vx-col md:w-1/2 mt-5">
            <vs-button
              class="float-left"
              color="danger"
              :disabled="visible"
              @click="deleteContract"
              >Apagar</vs-button
            >
          </div>
          <div class="vx-col md:w-1/2 mt-5">
            <vs-button class="float-right" color="success" @click="submit"
              >Salvar</vs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fileTools, momentJS } from "@/helpers";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { baseApiUrl } from "@/global";
import router from "@/router";
import axios from "axios";
import { Validator } from "vee-validate";
import { VueGoodTable } from "vue-good-table";
const dict = {
  custom: {
    customer: {
      required: "Selecione o cliente",
    },
    user: {
      required: "Selecione o Consultor",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: { vSelect, Datepicker, VueGoodTable },
  props: {},
  data() {
    return {
      columns: [],
      languages: lang,
      date: null,
      number: null,
      idContractPermanentAsset: null,
      corporateName: null,
      fantasyName: null,
      cpf: null,
      cnpj: null,
      city: null,
      idIlux: null,
      items: [],
      isMounted: false,
      type: "Sem Contrato",
      visible: false,
      newFiles: [],
      files: [],
      showSaveButton: false,
      fileTools: null,
      paginationOptions: {
        enabled: true,
        nextLabel: "Próxima",
        prevLabel: "Anterior",
        rowsPerPageLabel: "Resultados por página",
        ofLabel: "de",
        pageLabel: "Página",
        allLabel: "Todos",
        mode: "pages",
        perPage: 50,
      },
    };
  },
  computed: {},
  methods: {
    async submit() {
      try {
        let data = {
          date: this.date,
          number: this.number,
          type: this.type,
          idContractPermanentAsset: this.idContractPermanentAsset,
        };
        const responseAsset = await axios.post(
          `${baseApiUrl}/permanentAsset/updateContract`,
          data
        );

        this.$vs.loading.close();
        this.$vs.notify({
          title: "Salvo",
          text: "Com Sucesso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        if (responseAsset.status == "200") {
          router.push("/contratos").catch(() => {});
        }
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erro",
          text: "Problema ao Salvar",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
    async deleteContract() {
      try {
        let data = {
          idContractPermanentAsset: this.idContractPermanentAsset,
        };
        const responseAsset = await axios.post(
          `${baseApiUrl}/permanentAsset/deleteContract`,
          data
        );

        this.$vs.loading.close();
        this.$vs.notify({
          title: "Apagado",
          text: "Com Sucesso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        if (responseAsset.status == "200") {
          router.push("/contratos").catch(() => {});
        }
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erro",
          text: "Problema ao Apagar",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
    async attachFile() {
      this.showSaveButton = true;
      for (const element of this.$refs.attachmentInput.files) {
        let base64 = await this.fileTools.toBase64(element);
        let fileName = element.name;
        let type = element.type;
        let item = {
          fileName: fileName,
          file: base64,
          type: type,
          fk_idContractPermanentAsset: this.idContractPermanentAsset,
          createAt: momentJS().getDateTime(),
        };
        console.log(this.newFiles)
        this.newFiles.push(item);
      }
    },
    async clean() {
      this.newFiles = [];
      this.showSaveButton = false;
    },
    mountTable() {
      this.columns = [
        {
          label: "Código",
          field: "idItemContractPermanentAsset",
          tdClass: "align-middle",
        },
        {
          label: "Nome",
          field: "fileName",
          tdClass: "align-middle",
        },
        {
          label: "Criado",
          field: "createAt",
          tdClass: "align-middle",
          dateInputFormat: "dd/MM/yyyy",
          dateOutputFormat: "dd/MM/yyyy",
        },
        {
          label: "Download",
          field: "download",
          tdClass: "align-middle",
        },
        {
          label: "Apagar",
          field: "delete",
          tdClass: "align-middle",
        },
      ];
    },
    onRowClick(params) {
      // Somente para ter a mão do mouse clique
    },
    async submitFile() {
      try {
        this.$vs.loading();
        const res = await axios.post(
          `${baseApiUrl}/permanentAsset/uploadFile`,
          this.newFiles
        );
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        router
          .push(`/contratos/${this.$route.params.idContractPermanentAsset}`)
          .catch(() => {});
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel anexar os arquivos",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
        this.newFiles = [];
        this.loadContracts();
      }
    },
    async deleteFile(idItemContractPermanentAsset) {
      try {
        this.$vs.loading();
        const res = await axios.post(
          `${baseApiUrl}/permanentAsset/deleteFile`,
          { idItemContractPermanentAsset }
        );
        this.$vs.notify({
          title: "Excluido",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        router
          .push(`/contratos/${this.$route.params.idContractPermanentAsset}`)
          .catch(() => {});
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel deletar os arquivos",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
        this.newFiles = [];
        this.loadContracts();
      }
    },
    async downloadFile(fileName,base64,type) {
      
      try {
        this.$vs.loading();
        const response = await axios.get(base64, {
        responseType: "blob",
         });
        let blobFile = response.data
        const blobUrl = URL.createObjectURL(blobFile, { type });
        const fileElement = document.createElement("a");
        fileElement.href = blobUrl;
        fileElement.download = fileName;
        fileElement.click();
        this.$vs.notify({
          title: "Download efetuado",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel baixar os arquivos",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async loadContracts() {
      try {
        this.$vs.loading();

        const responseContracts = await axios.get(
          `${baseApiUrl}/permanentAsset/getContractPermanentAssetById/${this.$route.params.idContractPermanentAsset}`
        );
        this.date = responseContracts.data.contract[0].date;
        this.number = responseContracts.data.contract[0].number;
        this.type = responseContracts.data.contract[0].type;
        this.corporateName = responseContracts.data.contract[0].corporateName;
        this.fantasyName = responseContracts.data.contract[0].fantasyName;
        this.city = responseContracts.data.contract[0].city;
        this.idIlux = responseContracts.data.contract[0].idIlux;
        this.cnpj = responseContracts.data.contract[0].cnpj;
        this.cpf = responseContracts.data.contract[0].cpf;
        this.idContractPermanentAsset =
          responseContracts.data.contract[0].idContractPermanentAsset;
        this.items = responseContracts.data.items;
        this.files = responseContracts.data.files;
        if (this.items.length > 0) {
          this.visible = true;
        } else {
          this.visible = false;
        }
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });

        if (error.responseAsset.status == "400") {
          router.push(`/contratos`).catch(() => {});
        }
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    this.mountTable();
    this.fileTools = fileTools();
    await this.loadContracts();
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;
            span {
              display: flex;
              justify-content: flex-start;
            }
            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>